// @flow

import React, { Component } from 'react';
import Spinner from './spinner';
import { TILESERVER } from '../../src/config';
import { selectEncodedGeoJSONURL } from '../../src/modules/map';

const { fetch } = window;

type Props = {
  url: string,
  onListingsChange: (listings: Array<any>) => void,
};

type State = {
  density: number,
  loading: false | true | 'error' | 'done',
  listings: null | Array<any>,
};

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
  },
};

const listingTypes = ['best', 'better', 'good', 'bad', 'bad-split'];

const betterQuality = (quality) => {
  const index = listingTypes.indexOf(quality);
  return index > 0
    ? listingTypes[index - 1]
    : quality;
};

class ListingWidget extends Component<Props, State> {
  state = {
    density: 0,
    loading: false,
    listings: null,
  };

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (prevState.loading !== true && this.state.loading === true) {
      this.fetchFeatures();
    }
  }

  get listings(): Array<any> {
    const { density, listings } = this.state;
    if (!density) return [];
    if (!listings) return [];

    const densityPercentage = density / 100;

    const filteredListings = listings.filter(() => Math.random() < densityPercentage);

    return [
      ...filteredListings,
      ...filteredListings.map(listing => ({
        ...listing,
        id: `${listing.id}-betterPrice`,
        price: listing.price / 2,
      })),
      ...filteredListings.map(listing => ({
        ...listing,
        id: `${listing.id}-betterPriceAndQuality`,
        price: listing.price / 2,
        quality: betterQuality(listing.quality),
      })),
      ...filteredListings.map(listing => ({
        ...listing,
        id: `${listing.id}-betterQuality`,
        quality: betterQuality(listing.quality),
      })),
    ];
  }

  get encodedGeoJSONURL(): string | null {
    const { url } = this.props;
    const state = { map: { url } };

    return selectEncodedGeoJSONURL(state);
  }

  sendListings = () => {
    this.props.onListingsChange(this.listings);
  };

  async fetchFeatures() {
    try {
      const { encodedGeoJSONURL } = this;

      if (!encodedGeoJSONURL) throw new Error(`Invalid GeoJSON URL: ${this.props.url}`);

      const url = `${TILESERVER}/${encodedGeoJSONURL}/listings.json`;
      const features = await (await fetch(url)).json();

      this.setState({
        loading: 'done',
        listings: features,
      }, this.sendListings);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);

      this.setState({ loading: 'error' });
    }
  }

  updateDensity = (event: any) => {
    const density = parseInt(event.target.value, 10);
    this.setState(({ loading }) => {
      if (density && !loading) {
        return { density, loading: true };
      }

      return { density };
    }, this.sendListings);
  };

  render() {
    if (this.state.loading === 'error') {
      return (
        <div style={styles.container}>
          Error generating listings
        </div>
      );
    }

    return (
      <label
        htmlFor="listing-density-slider"
        style={styles.container}
      >
        <span>Listing Density</span>
        <input
          id="listing-density-slider"
          type="range"
          min={0}
          max={100}
          step={1}
          value={this.state.density}
          onChange={this.updateDensity}
        />
        {this.state.loading === true && <Spinner />}
      </label>
    );
  }
}

export default ListingWidget;



// WEBPACK FOOTER //
// ./demo/src/listing-widget.js